var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:{ 'vertical-align-sub': _vm.data.isIcon },attrs:{"href":_vm.data.href,"target":_vm.data.target,"rel":"noopener"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.name)}},[_vm._v(_vm._s(_vm.data.name))]),_c('span',{staticClass:"anchor-underline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }